// Used in filter-menu.component.ts

import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { filter } from "rxjs/operators";

@Injectable()
export class FilterMenuHelper {
    clearDisplayFilterParams: Subject<any> = new BehaviorSubject<any>(null);
    dataLoading: Subject<any> = new BehaviorSubject<any>(null);

    constructor() {}

    // display Filter Params
    get clearDisplayFilterParams$() {
        return this.clearDisplayFilterParams
            .asObservable()
            .pipe(
                filter((clearDisplayFilterParams) => !!clearDisplayFilterParams)
            );
    }
    setClearDisplayFilterParams(data: any) {
        this.clearDisplayFilterParams.next(data);
    }

    // get set loading data in order to disable enable filters
    get dataLoading$() {
        return this.dataLoading
            .asObservable()
            .pipe(filter((dataLoading) => !!dataLoading));
    }
    setDataLoading(data: any) {
        this.dataLoading.next(data);
    }
}
